export default "__VITE_ASSET__M2CbU3NE__"